import createSpacing from '@material-ui/core/styles/createSpacing';

const SPACING = 8;

export default createSpacing(SPACING);
